import { getFormattedTime } from '../../../run-info/analysis-v2/utils'
import type { EvalStreamEntry } from '../../../types'
import { EVENT_LABELS } from '../constants'

const formatPayload = (payload: unknown): string => {
  if (payload === null || payload === undefined) return '—'
  try {
    return JSON.stringify(payload, null, 2)
  } catch (_error) {
    return String(payload)
  }
}

interface EvalEntryRendererProps {
  entry: EvalStreamEntry
}

export const EvalEntryRenderer = ({ entry }: EvalEntryRendererProps) => {
  const label = EVENT_LABELS[entry.type] ?? entry.type
  return (
    <div className="border border-st2 rounded-lg bg-background px-4 py-3 space-y-2">
      <div className="flex items-center justify-between text-xs-400">
        <span className="text-xs-500">{label}</span>
        <span className="font-jetbrains tabular-nums">
          {getFormattedTime(entry.receivedAt.toString())}
        </span>
      </div>
      <pre className="whitespace-pre-wrap break-words text-xs-400 font-jetbrains">
        {formatPayload(entry.payload)}
      </pre>
    </div>
  )
}
